/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Panel_HeadingInputs */

const en_login_panel_heading = /** @type {(inputs: Login_Panel_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Belgrade you'll want to come back to.`)
};

/**
* | output |
* | --- |
* | "A Belgrade you'll want to come back to." |
*
* @param {Login_Panel_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const login_panel_heading = /** @type {((inputs?: Login_Panel_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Panel_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_login_panel_heading(inputs)
});